import cls from "classnames";
import { useState } from "react";
import Spinner from "@qoohoo/common/library/loader/Spinner";

export default function EmptyTab({ tabName = "upcoming sessions & events" }) {
  const [isLoading, setLoading] = useState(true);

  return (
    <>
      {isLoading && (
        <div className="mt-6 sm:mt-20 mx-auto h-[292px] sm:h-[330px] flex justify-center items-center">
          <Spinner size="lg"/>
        </div>
      )}
      <div
        className={cls(
          "mt-6 sm:mt-20 mx-auto text-center",
          isLoading && "hidden"
        )}
      >
        <img
          className="mx-auto h-56 sm:h-64"
          src="/assets/images/no-results.svg"
          alt="No results image"
          onLoad={() => {
            setLoading(false);
          }}
        />
        <h3 className="mt-11 text-[#A6A6A6] sm:text-xl sm:leading-[30px]">
          {`No ${tabName} yet`}
        </h3>
      </div>
    </>
  );
}
